<div class="color-picker-container">
    <!-- Color Picker -->
    <div *ngIf="customPickerVisible" class="color-picker-popup">
        <input class="d-none"
               [(colorPicker)]="selectedColor"
               [cpDialogDisplay]="'inline'"
               [cpToggle]="true"
               [cpOutputFormat]="'hex'"
               [cpAlphaChannel]="'disabled'"
               [cpPresetColors]="[]"
               [cpWidth]="'230px'"
               [cpHeight]="'150px'"
               [cpPosition]="'right'"
               [cpPositionRelativeToArrow]="true"
               [cpOKButton]="false"
               [cpCancelButton]="false"
               (colorPickerChange)="emitColorChange($event, 'color-picker')"
        >
    </div>
    <div *ngIf="labelText" class="theme-text">
        {{labelText}}
    </div>
    <div #colorContainer class="color-container">
        <div
            *ngFor="let color of colorOptions; let i = index"
            class="color-circle"
            [ngStyle]="{ 'background-color': color}"
            (click)="emitColorChange(color, 'default-colors')"
            (keyup)="emitColorChange(color, 'default-colors')"
            (keydown)="emitColorChange(color, 'default-colors')"
        >
            <img *ngIf="color === selectedColor" class="tick-mark" src="../../../assets/img/tick-mark.svg" alt="tick-mark"/>
        </div>

        <div
            class="color-picker-circle position-relative d-flex align-items-center justify-content-center"
            (click)="togglePicker($event)"
            (keydown)="togglePicker($event)"
            (keyup)="togglePicker($event)"
        >
            <!-- Inner Circle -->
            <div class="inner-circle d-flex align-items-center justify-content-center">
                <img src="../../../assets/img/roll-brush.svg" alt="roll-brush"/>
            </div>
        </div>

    </div>
</div>

